/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React, { useEffect, useState } from "react";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";
import defaultUserImage from "assets/images/default-user.png";

export default function data() {
  const [rows, setRows] = useState([]);

  const Author = ({ image, name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDAvatar src={image} name={name} size="sm" />
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{email}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const Job = ({ title, description }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography display="block" variant="caption" color="text" fontWeight="medium">
        {title}
      </MDTypography>
      <MDTypography variant="caption">{description}</MDTypography>
    </MDBox>
  );

  const columns = [
    { Header: "Pracownik", accessor: "author", width: "45%", align: "left" },
    { Header: "Dział", accessor: "function", align: "left" },
    { Header: "Uprawnienia", accessor: "status", align: "center" },
    { Header: "Dołączył", accessor: "employed", align: "center" },
    { Header: "Działanie", accessor: "action", align: "center" },
  ];

  const exampleRows = [
    {
      author: <Author image={defaultUserImage} name="Anton Mekh" email="amekh@devcolibri.pl" />,
      function: <Job title="IT" description="" />,
      status: (
        <MDBox ml={-1}>
          <MDBadge badgeContent="admin" color="success" variant="gradient" size="sm" />
        </MDBox>
      ),
      employed: (
        <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
          22/01/2024
        </MDTypography>
      ),
      action: (
        <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
          Edytuj
        </MDTypography>
      ),
    },
  ];

  // setRows(exampleRows);

  const fetchDataFromServer = async () => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/fetch-users.php");
      const data = await response.json();
      const updatedRows = data.map((userData) => formatUserData(userData));
      setRows(updatedRows);
      return data;
    } catch (error) {
      console.error("Błąd podczas pobierania danych z serwera:", error);
      return [];
    }
  };

  useEffect(() => {
    fetchDataFromServer(); // Wywołaj funkcję pobierającą dane z serwera po zamontowaniu komponentu
  }, []); // Pusta tablica zależności oznacza, że useEffect zostanie uruchomiony tylko raz po zamontowaniu komponentu

  // Funkcja pomocnicza do formatowania danych użytkownika
  const formatUserData = (userData) => ({
    author: (
      <Author
        image={defaultUserImage} // Pamiętaj, aby dostosować to pole do rzeczywistych danych użytkownika
        name={userData.first_name + " " + userData.last_name}
        email={userData.email}
      />
    ),
    function: <Job title={userData.department} description="" />,
    status: (
      <MDBox ml={-1}>
        <MDBadge badgeContent={userData.is_admin ? "Admin" : "User"} color={userData.is_admin ? "success" : "error"} variant="gradient" size="sm" />
      </MDBox>
    ),
    employed: (
      <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
        {new Date(userData.created_at).toISOString().split("T")[0]}
      </MDTypography>
    ),
    action: (
      <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
        Edytuj
      </MDTypography>
    ),
  });

  return {
    columns,
    rows,
  };
}
